/**
 * Hook для debounce значения
 * ✅ УЛУЧШЕНИЕ: Уменьшает количество API запросов при поиске
 * 
 * @param value - значение для debounce
 * @param delay - задержка в миллисекундах (по умолчанию 500мс)
 * @returns debounced значение
 * 
 * @example
 * const debouncedSearch = useDebouncedValue(search, 400);
 */
import { useState, useEffect } from 'react';

export function useDebouncedValue<T>(value: T, delay: number = 500): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(timer);
    };
  }, [value, delay]);

  return debouncedValue;
}

/**
 * @deprecated Используйте useDebouncedValue вместо useDebounce
 * Оставлено для обратной совместимости
 */
export const useDebounce = useDebouncedValue;

